export default __webpack_public_path__ + "static/media/Futura-Demi.a3c324a6.woff";